import { useEffect, useState } from "react";
import useFetch from "hooks/useFetch";

const defaultUserType = "GUEST";
const cacheMinutes = 0;

const useProfile = ({
	store,
	profile,
	defaultBaseApiUrl,
	makeProfileRequest,
}) => {
	const [userType, setUserType] = useState(null);
	const [user, setUser] = useState(null);
	const [profileUrl, setProfileUrl] = useState(null);
	const { response, error } = useFetch(profileUrl, {
		options: {},
		trigger: profileUrl,
		cacheValidMinutes: cacheMinutes,
	});

	const getLoggedInUser = (event) => {
		if (event?.detail?.event === "userInformation" && event.detail.data) {
			const {
				firstName,
				lastName,
				email,
				swid,
				telephone,
				title,
				country,
			} = event.detail.data;
			setUser({ firstName, lastName, email, swid, telephone, title, country });
		}
	};

	useEffect(() => {
		document.addEventListener("navigation", getLoggedInUser);
		return () => document.removeEventListener("navigation", getLoggedInUser);
	}, []);

	useEffect(() => {
		if (makeProfileRequest && profile?.path && defaultBaseApiUrl) {
			setProfileUrl(`${defaultBaseApiUrl}${profile?.path}`);
		} else {
			if (store) {
				setUserType("TRAVEL_AGENT");
			} else {
				setUserType(defaultUserType);
			}
		}
	}, [profile, defaultBaseApiUrl, store, makeProfileRequest]);

	useEffect(() => {
		if (response) {
			if (response.userType) {
				setUserType(response.userType);
			} else {
				setUserType(defaultUserType);
			}
		}
	}, [response]);

	useEffect(() => {
		if (error) {
			setUserType(defaultUserType);
		}
	}, [error]);

	return { user, userType };
};

export default useProfile;
